var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-m-5"},[_c('div',[_c('h1',[_vm._v("Welcome to the Academy Wizard!")]),_c('p',[_vm._v(" To start making changes, simply select a section from the left hand side and begin filling it in ")])])])
}]

export { render, staticRenderFns }